module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-columns"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column content",
    class: [{
      'is-11': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined),
      backgroundColor: (_vm.backgroundColor ? _vm.backgroundColor : undefined),
      textAlign: (_vm.textAlign ? _vm.textAlign : undefined)
    }])
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4e48ea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DivColumns.vue
// module id = 941
// module chunks = 1